/* global wx */
import {message} from 'antd'

export function invokeWx (method, opts = {}) {
  return new Promise((resolve, reject) => {
    wx.invoke(method, opts, res => {
      // res.err_msg | res.errmsg | res.errMsg
      if (res.err_msg === `${method}:ok`) {
        resolve(res)
      } else {
        reject(new Error(res.err_msg || res.errmsg))
      }
    })
  })
}

/**
 * 获取企微版本，如果不是企微，返回null
 * @return {string|null}
 */
export function getWxworkVersion () {
  const matchRes = navigator.userAgent.toLowerCase().match(/\bwxwork\/([\d.]+)\b/)
  if (matchRes) {
    return matchRes[1]
  } else {
    return null
  }
}

// 官网-SigoWeb
// 天猫 -Tmall
// 京东 -JD
// 抖音 -DOUYIN
// 拼多多-PDD
// 其他 -OTHER
/**
 * @description: 获取相关渠道数据
 * @return {*}
 */
export const CHANNEL_DATA = [
  {title: '官网', value: 'SigoWeb'},
  {title: '天猫', value: 'Tmall'},
  {title: '京东', value: 'JD'},
  {title: '抖音', value: 'DOUYIN'},
  {title: '拼多多', value: 'PDD'},
  {title: '其他', value: 'OTHER'}
]
/**
 * @description: 订单状态
 * @return {*}
 */
export const ORER_STATUS_MAP = {
  'CREATE': {title: '已创建待付款'},
  'PAID': {title: '已付款'},
  'PART_PAID': {title: '部分付款'},
  'SEND': {title: '已发货'},
  'PART_SEND': {title: '部分发货'},
  'CANCEL': {title: '已取消'},
  'default': {title: '未知'}
}
/**
 * @description: 发送小程序卡片分享
 * @return {*}
 */
export function qwWxShareFn ({link, title, imgUrl, brandName, webUrl}) {
  const utmCampaign = localStorage.getItem('utm_campaign')
  const query = `utm_term=${brandName}&utm_source=sq_pp&utm_medium=sqkqk&utm_campaign=${utmCampaign}`
  console.log({
    appid: 'wxa2a01f8b03b59cc3', // 小程序的appid，企业已关联的任一个小程序
    title: title, // 小程序消息的title
    imgUrl: imgUrl, // 小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
    page: link + (link.indexOf('?') > 0 ? '&' : '?') + query // 小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
  })
  if (getWxworkVersion()) {
    wx.invoke('sendChatMessage', {
      msgtype: 'miniprogram',
      miniprogram: {
        appid: 'wxa2a01f8b03b59cc3', // 小程序的appid，企业已关联的任一个小程序
        title: title, // 小程序消息的title
        imgUrl: imgUrl, // 小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
        page: link + (link.indexOf('?') > 0 ? '&' : '?') + query // 小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
      }
    }, res => {
      if (res.err_msg !== 'sendChatMessage:ok') {
        message.error('发送消息失败')
      }
    })
  } else {
    navigator.clipboard.writeText(webUrl + (webUrl.indexOf('?') > 0 ? '&' : '?') + query)
    message.info('当前浏览器不支持发送小程序卡片,已复制链接到粘贴板')
  }
}



// WEBPACK FOOTER //
// ./src/pages/udeskSide/utils.js